import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). 3 damage, then 3 more if a fresh die
 * lands even — bounded "repeat", depth-1-safe. */
export const ECHOES: Card = {
  id: 'echoes',
  name: 'Echoes',
  type: 'recursive',
  rarity: 'epic',
  size: { w: 2, h: 1 },
  cost: [{ kind: 'min', value: 5 }],
  effects: [
    { kind: 'damage', amount: 3, target: 'opponent' },
    {
      kind: 'rollFresh',
      count: 1,
      perFace: [
        {
          facePredicate: { kind: 'parity', value: 'even' },
          effects: [{ kind: 'damage', amount: 3, target: 'opponent' }],
        },
      ],
    },
  ],
};
